/* Landing cortina — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'cortina'). */


const PRICES={3:{1:119900,2:199900,3:269900},6:{1:169900,2:299900,3:419900}};
const state={size:3,color:'Cálido',qty:2};
const fmt=n=>'$'+Math.round(n).toLocaleString('es-CO');
const $=id=>document.getElementById(id);

function render(){
  const tbl=PRICES[state.size];
  document.querySelectorAll('.combo').forEach(c=>{
    const q=+c.dataset.qty,p=tbl[q],save=tbl[1]*q-p;
    c.classList.toggle('on',q===state.qty);
    c.querySelector('input').checked=q===state.qty;
    c.querySelector('[data-sub]').textContent=state.size+' m'+(q>1?' · '+fmt(p/q)+' c/u':' · '+(state.size===3?'12':'24')+' estrellas');
    c.querySelector('[data-price]').innerHTML=fmt(p)+(save>0?'<span class="cSave">Ahorras '+fmt(save)+'</span>':'');
  });
  const p=tbl[state.qty];
  $('nowP').textContent=fmt(p);
  $('perP').textContent=state.qty>1?fmt(p/state.qty)+' c/u':'';
  const n=state.size+' m · '+state.color+' · '+state.qty+(state.qty>1?' ventanas':' ventana');
  $('sName').textContent=n;
  $('sPrice').textContent=fmt(p)+' · Pagas al recibir';
  $('colorName').textContent='· '+state.color;
}
function showImg(src){
  $('mainImg').src=src;
  document.querySelectorAll('#thumbs button').forEach(x=>x.classList.toggle('on',x.dataset.src===src));
}
document.querySelectorAll('#thumbs button').forEach(b=>b.addEventListener('click',()=>showImg(b.dataset.src)));
document.querySelectorAll('.size').forEach(b=>b.addEventListener('click',()=>{
  state.size=+b.dataset.size;document.querySelectorAll('.size').forEach(x=>x.classList.toggle('on',x===b));render();
}));
document.querySelectorAll('.color').forEach(b=>b.addEventListener('click',()=>{
  state.color=b.dataset.color;document.querySelectorAll('.color').forEach(x=>x.classList.toggle('on',x===b));showImg(b.dataset.img);render();
}));
document.querySelectorAll('.combo').forEach(c=>c.addEventListener('click',()=>{state.qty=+c.dataset.qty;render();}));

/* diagrama de medidas: 12 tiras, estrellas pequeñas (50 cm) y grandes (80 cm) intercaladas */
(function(){
  const g=$('strands'),ns='http://www.w3.org/2000/svg';let h='';
  for(let i=0;i<12;i++){
    const x=58+i*37,big=i%2===0,y=big?232:160,s=big?1.9:1.2;
    h+=`<line x1="${x}" y1="40" x2="${x}" y2="${y-(big?17:10)}" stroke="#8a97b5" stroke-width="1"/>`;
    for(let k=58;k<y-18;k+=26)h+=`<circle cx="${x}" cy="${k}" r="2.4" fill="#ffd98a"/>`;
    h+=`<use href="#st" transform="translate(${x} ${y}) scale(${s})" fill="${big?'none':'#ffe7a8'}" stroke="#ffd98a" stroke-width="${big?1.4:0}"/>`;
  }
  g.innerHTML=h;
})();

render();
const buy=$('comprar'),st=$('sticky');
new IntersectionObserver(([e])=>st.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0)).observe(buy);

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN (memoria project-northpower-landing / project-diosa-landing):
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug NorthPower #1019).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe.

     La cortina tiene DOS ejes propios (tamaño y color) que sí son variantes
     reales de Dropi, así que la variante se resuelve por título: se normaliza
     (sin tildes, mayúsculas) y se exige que contenga el tamaño (3 M / 6 M) y
     el color elegidos. Si el producto aún no está importado, o el título no
     matchea, cae a window.CORTINA_VARIANT (la primera disponible). */
  function norm(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toUpperCase().replace(/[^A-Z0-9]+/g, ' ').trim();
  }

  function matchVariant(size, color) {
    var list = window.CORTINA_VARIANTS || [];
    if (!list.length) return window.CORTINA_VARIANT;
    var c = norm(color);
    var sizeRe = new RegExp('(^|[^0-9])' + size + '\\s?M');
    var hit = list.filter(function (v) {
      var t = norm(v.title);
      return sizeRe.test(t) && t.indexOf(c) !== -1;
    })[0];
    // si no cruza los dos ejes, intentar solo por tamaño
    if (!hit) {
      hit = list.filter(function (v) { return sizeRe.test(norm(v.title)); })[0];
    }
    return hit ? hit.id : window.CORTINA_VARIANT;
  }

  function current() {
    var root = document.querySelector('.cortina-landing') || document;
    var sizeEl  = root.querySelector('.sizes .size.on')   || root.querySelector('.sizes .size');
    var colorEl = root.querySelector('.colors .color.on') || root.querySelector('.colors .color');
    var card    = root.querySelector('.combos .combo.on') || root.querySelector('.combos .combo');
    var size  = sizeEl  ? (sizeEl.getAttribute('data-size') || '3') : '3';
    var color = colorEl ? (colorEl.getAttribute('data-color') || '') : '';
    return {
      id: matchVariant(size, color),
      qty: card ? (parseInt(card.getAttribute('data-qty'), 10) || 1) : 1
    };
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.sizes .size, .colors .color, .combos .combo')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.cortinaTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
